import Vue from "vue"
import errorCodesService from '@shared/src/services/errorCodesService'
import store from '@store/index'
import {eventBus} from '@shared/src/services/eventBus'
import {_CONST} from "@/constants/constants"
import {ES, LS, SS} from "@services/ls";
import {authService} from "@services/authService";
import { AxiosPromise, AxiosResponse } from "axios"

const DEFAULT_ERROR_CODE = 1000
const axios = Vue.prototype.$axios
const apiUrl = new URL(window.__env.apiUri)

interface httpPromiseModel {
  path: string,
  method: string,
  query?: any,
  params?: any,
  data?: any,
  options?: any,
  config?: any,
}

const getAccessToken = () => {
  return store.getters['main/accessToken']
}

const getRefreshToken = () => {
  return store.getters['main/refreshToken']
}

const getHeaders = () => {
  const headers: any = {}
  const token = getAccessToken()

  if (!!token) headers['X-CSRF-TOKEN'] = token

  return headers
}

const logOut = () => {
  eventBus.$emit(_CONST.event.logout)
}

const welcome = (res: any) => {
  eventBus.$emit(_CONST.event.welcome, res)
}

const refreshToken = authService.refresh

const httpPromise = async ({path = '', query = null, method = 'POST', params = null, data = null, options = {}, config = null}: httpPromiseModel ) => {

  if (options?.query) query = {...options.query}

  const checkRefresh = (resolve: any, reject: any) => {
    if (!isRefresh)  {
      go(resolve, reject);
      return;
    }

    setTimeout(() => {
      checkRefresh(resolve, reject)
    }, 100);
  };

  const go = (resolve: (value: AxiosResponse) => void, reject: any) => {
    Vue.prototype.$axios({
      method,
      url: path,
      params: query?.params,
      data,
      withCredentials: true,
      headers: getHeaders(),
    })
        .then(resolve)
        .catch(async (error: any) => {
          if (error.response.status === 401) {
            if (isRefresh) {
              checkRefresh(resolve, reject);
              return;
            }

            isRefresh = true;
            const res = await refreshToken();
            if (!!res) {
              welcome(res)
            }

            go(resolve, reject);
            isRefresh = false;
            return;
          }

          reject(error);

          if (error.response.status === 400 && error.response.data.Errors) {
            const stopCodes = options?.stopCodes || [];

            error.response.data.Errors.forEach((e: any) => {

              if (stopCodes.includes(+e.Code)) return;

              const message = errorCodesService.getTextByCode({
                code: e.Code,
                defaultText: e.Message,
                lang: 'en',
                params: e.Data
              })

              Vue.prototype.$q.notify({
                color: 'negative',
                message
              });
            });

            return;
          }

          if (error.response.status === 403) return

          Vue.prototype.$q.notify({
            color: 'negative',
            message: errorCodesService.getTextByCode({code: DEFAULT_ERROR_CODE, lang: 'en', defaultText: undefined, params: undefined})
          });
        });
  };

  return new Promise<AxiosResponse>((resolve, reject) => {
    go(resolve, reject);
  });
}

const httpWrapper = {
  get(path: string, query?: any, config?: any, options?: any) {
    return httpPromise({path, query, config, method: 'GET', options});
  },
  delete(path: string, query?: any, config?: any, options?: any) {
    return httpPromise({path, query, config, method: 'DELETE', options});
  },
  post(path: string, query?: any, config?: any, options?: any) {
    return httpPromise({path, data: query, config, method: 'POST', options});
  },
  patch(path: string, query?: any, config?: any, options?: any) {
    return httpPromise({path, data: query, config, method: 'PATH', options});
  },
  put(path: string, data?: any, query?: any, config?: any, options?: any) {
    return httpPromise({path, data, query, config, method: 'PUT', options});
  },
}

let isRefresh = false

export class Repo {
  pathUrl: URL;
  http: typeof httpWrapper;

  constructor(controllerName: string) {
    this.pathUrl = new URL(controllerName, apiUrl);

    this.http = httpWrapper;
  }

  getPath(method?: string): string {
    if (!method) return this.pathUrl.href;

    const methodUrl: URL = new URL(this.pathUrl.pathname + '/' + method, this.pathUrl);
    return methodUrl.href;
  }

  getDefaultQuery():object {
    return {}
  }

  wrapSort(query: any): any {
    if (!query) query = {};

    query = {
      ...query,
      pageNumber: query.page,
      pageSize: query.rowsPerPage,
      sorting: `${query.sortBy} ${query.descending ? 'DESC' : 'ASC'}`,
    };

    if (!query.sortBy) delete query.sorting;

    delete query.sortBy;
    delete query.descending;
    delete query.page;
    delete query.rowsPerPage;

    return query;
  }

  convertToUrlParams(query: any): object {
    let result: { params: any } = {
      params: {}
    };

    if (query) {
      for (let key in query) {
        result.params[key] = encodeURI(query[key]);
      }
    }

    return result;
  }
}
